import React from 'react'
import { Link } from 'react-router-dom'
import { isAuthenticated, logout } from '../../services/self'
import SignIn from '../../components/SignIn'
import Register from '../../components/Register'
import logo from '../../Nlogo.png'
import slack from '../../images/slack.jpeg'
import bst from '../../images/bst.png'
import avitru from '../../images/avitru.png'



export default class CaseStudies extends React.Component{

  logout() {
    logout()
    this.setState({ loggedOut: true })
  }





render() {


  return(
  <div>

      <div className="Logo">
        <Link className="home-link2" to='/'><img src={logo} className="App-logo" alt="logo" /></Link>
        <Link className="home-link" to='/'>Developer</Link>
      </div>

      <div className="Navbar-Div">
        <nav className="App-navbar">
        <Link className="Centered-link" to='/updates'>Updates</Link>
        <Link className="Centered-link" to='/getting-started'>Getting Started</Link>
        <Link className="Centered-link" to='/documentation'>Docs</Link>
        <Link className="Centered-link" to='/tools'>Tools</Link>
        <Link className="Centered-link" to='/community'>Community</Link>


        <div className="right">
          {isAuthenticated() ? (<Link to='/account'>Account</Link>) : ''}
          {isAuthenticated() ? (<Link to='' onClick={() => this.logout()}>Log out</Link>) : ''}
        </div>

            {isAuthenticated() ? '' : (
              <span className="right">
                <SignIn className="right" />
                <Register className="right-link" />
              </span>
            )}
        </nav>
      </div>

      <div className="App-banner">

        <span className="orange-bold">  NEWFORMA CONNECTED </span> 

      </div>


      <div className="content2">
        <div className="left-col">
        <h1 className="left-col-heading">Community</h1>

        <ul className="left-col-ul">
          <li><a className="doc-link" href="#faq">FAQ</a></li>
          <li><a className="doc-link" href="#communicate">Communicate</a></li>
          <li><a className="doc-link" href="#partners">Partners</a></li>
        </ul>

        </div>

        <div className="right-col-community">







        {/*-----------FAQ?------------------------ */}
              {/*<hr className="full-hr"></hr>*/}

              <h1 className="introduction-header">FAQ</h1>
              <div className="targetHelper" id="faq"></div>


              <p className="introduction-p-italic">
              Have a question about our APIs? Please see our FAQs to see if we have already answered it for you!
              </p>
              <hr className="short-hr"></hr>
              <h1 className='sub-introduction-header'>How do I authenticate my app to make calls to Newforma's API endpoints?</h1>

              <p className='introduction-p'>
                Visit the <Link to='getting-started'>Getting-Started</Link> page on the Newforma Developer Portal to read about the steps necessary to authenticate.
              </p>

              <h1 className='sub-introduction-header'>What kind of support do you offer for APIs?</h1>

              <p className='introduction-p'>
                If you need help please request an invite to our API specific Slack channel. We also monitor StackOverflow for posts
                tagged with #NewformaAPI. If you require direct support from Newforma please email support@newforma.com and your request will be routed
                through our Support Team.
              </p>



          {/*-----------Communicate------------------------ */}
                    {/*<hr className="full-hr"></hr>*/}

                    <h1 className="introduction-header">Communicate</h1>
                    <div className="targetHelper" id="communicate"></div>


                    <hr className="short-hr"></hr>
                    <img src={slack} alt="slack" className="slack-img" />
                    <p className="introduction-p">
                        We want to hear from you! To join our community please request an invite to our <a href="#">Slack Channel</a>. The channel is monitored by our API
                        Team to provide feedback and answers to the questions or ideas you have.
                    </p>

          {/*-----------Partners------------------------ */}
                    {/*<hr className="full-hr"></hr>*/}

                    <h1 className="introduction-header">Partners</h1>
                    <div className="targetHelper" id="partners"></div>
                      <h1 className='sub-introduction-header'>Who is using our APIs today?</h1>

                    <hr className="short-hr"></hr>

                    <p className="partners"> Alliance Partner</p>
                    <a href="https://www.newforma.com/bst/"><img  src={bst} alt="bst" className="bst-img" /></a>
                    <p className="partners"> Connection Partners </p>
                    <a href="https://www.newforma.com/bst/"><img src={avitru} alt="avitru" className="avitru-img" /></a>
        </div>


      </div>

    </div> )


  }

}



/** WEBPACK FOOTER **
 ** ./src/pages/Community/index.js
 **/